import { render, staticRenderFns } from "./claim-detail-dialog.vue?vue&type=template&id=4092d19e&scoped=true&"
import script from "./claim-detail-dialog.vue?vue&type=script&lang=js&"
export * from "./claim-detail-dialog.vue?vue&type=script&lang=js&"
import style0 from "./claim-detail-dialog.vue?vue&type=style&index=0&id=4092d19e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4092d19e",
  null
  
)

export default component.exports